import { convertSecondsToHMS } from 'util/time';

/**
 * @class
 * A representation of a PodcastEpisode
 *
 * @param {object} episode - episode from graphQL response
 * @param {object} podcast - podcast content model from graphQL response
 */
export default class PodcastEpisode {
  constructor(episode, podcast) {
    if (!episode || !podcast) {
      return null;
    }

    this.id = episode.id;
    this.name = episode.title;
    this.slug = episode.slug;
    this.title = episode.title;
    this.description = episode.description;
    this.audioUrl = episode.media && !!episode.media.length && episode.media[0].uri;
    this.duration = convertSecondsToHMS(episode.durationSeconds);
    this.imageUrl = podcast.image && podcast.image.url;
    this.publishDate = episode.publishDate;
    this.showNewLabel = episode.showNewLabel;
    this.progress = episode.progress;
    this.contentTypeId = episode.type;
    // Podcast specific props
    this.pageUrl = podcast.slug;
    this.pageName = podcast.title;
    // add reference to Podcast
    this.podcast = {
      id: podcast.id,
      uuid: podcast.id,
      author: podcast.subTitle,
      slug: podcast.slug,
      title: podcast.title,
      description: podcast.description,
      contentTypeId: podcast.type,
      relatedPodcast: podcast.relatedPodcast,
      genres: podcast.genres,
      userPreference: podcast.userPreference,
    };

    // Make this class read-only
    Object.freeze(this);
  }
}
